import { FormValidator } from '../../utils';

export class SecurityQuestionsValidator extends FormValidator {}
